import './FaqSection.scss';

import { Container } from 'react-bootstrap';

import { FaqAccordion, type FaqAccordionItem } from '@components/FaqAccordion/FaqAccordion';
import { MarketingSectionIntro } from '@components/marketing/MarketingSectionIntro/MarketingSectionIntro';

const FAQ_ITEMS: FaqAccordionItem[] = [
  {
    id: 'report-privacy',
    question: 'Will my relatives see my genetic testing report?',
    answer:
      'No. Your report is private to you and your care team. When we contact your relatives, we tell them only that a close family member has been tested and that they may be eligible for no-charge testing themselves. We never share your name, your results, or your report.',
  },
  {
    id: 'time',
    question: 'How long does this take me right now?',
    answer:
      "About 5 minutes for typical families: one row per relative with their name, relationship, and email. You can save and come back if you don't have all the info handy.",
  },
  {
    id: 'missing-email',
    question: "What if I don't have a relative's email?",
    answer:
      'Skip them for now and come back later when you have it. We only contact relatives we have a working email for. The "talking points" above are a good way to ask in the meantime.',
  },
  {
    id: 'decline',
    question: 'Can a relative decline or change their mind later?',
    answer:
      "Yes. Each relative can decline the invitation, pause partway through, or withdraw after starting. Their decisions are theirs alone. We don't show them back to you to protect their privacy.",
  },
  {
    id: 'acceptance',
    question: 'Will I see whether my relatives accepted?',
    answer:
      "We confirm here which invitations were sent and whether the email was successfully delivered. We don't show whether each one opened, accepted, or declined. That's private to them.",
  },
];

export const FaqSection = () => (
  <section className='fvt-faq marketing-section' aria-labelledby='fvt-faq-heading'>
    <Container fluid='xxl'>
      <MarketingSectionIntro
        variant='fvt'
        eyebrow='Common questions'
        heading="Things you'll probably wonder"
        headingId='fvt-faq-heading'
      />

      <FaqAccordion
        className='fvt-faq__accordion'
        items={FAQ_ITEMS}
        defaultOpenIds={FAQ_ITEMS[0] ? [FAQ_ITEMS[0].id] : []}
        idPrefix='fvt-faq'
      />
    </Container>
  </section>
);
